export const imagePath = (fileName) => {
    return `https://d3nvesd3xvdinx.cloudfront.net/images/${fileName}`;
};
//# sourceMappingURL=assets.js.map